import React, { FC } from 'react';
import { TextButton } from '../button';

type Props = {
  onClick: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
};

export const SeeMore: FC<Props> = ({ children, onClick }) => (
  <TextButton onClick={onClick}>{children}</TextButton>
);
